import { useState } from "react";
import { ACTIONS_ELEMENTS, ALL_ELEMENTS, ELEMENTS, PARAMETER_EVENT } from "../../utils/constants";
import { activeIcon } from "../../utils";
import useOrientationAdjustment from '../orientationAdjustment/useOrientationAdjustment'

const useProfileAdjustment = () => {
    const { readingMask, animationsStop } = useOrientationAdjustment();
    let html = document.getElementsByTagName("html")[0];
    let body = document.getElementsByTagName("body")[0];

    const [screenReaderToggle, setScreenReaderToggle] = useState(false)

    //  SEIZURE SAFE PROFILE  //
    function SeizureSafeProfile(CheckMark) {
        const enableSeizureSafeProfile = () => {
            html.classList.add("rcp-seizure-safe-profile");
            localStorage.setItem("rcp-seizure-safe-profile", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        }

        const disableSeizureSafeProfile = () => {
            html.classList.remove("rcp-seizure-safe-profile");
            localStorage.removeItem("rcp-seizure-safe-profile");
            activeIcon(PARAMETER_EVENT.NONE);
        }

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            html.classList.contains("rcp-seizure-safe-profile") ? disableSeizureSafeProfile() : enableSeizureSafeProfile();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableSeizureSafeProfile()
        }
    }

    //  VISION IMPAIRED PROFILE  //
    function visionImpairedProfile(CheckMark) {
        const enableVisionImpairedProfile = () => {
            html.classList.add("rcp-vision-impaired-profile");
            localStorage.setItem("rcp-vision-impaired-profile", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        }
        const diableVisionImpairedProfile = () => {
            html.classList.remove("rcp-vision-impaired-profile");
            localStorage.removeItem("rcp-vision-impaired-profile");
            activeIcon(PARAMETER_EVENT.NONE);
        }

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            html.classList.contains("rcp-vision-impaired-profile") ? diableVisionImpairedProfile() : enableVisionImpairedProfile();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableVisionImpairedProfile();
        }
    }

    //  ADHD FRIENDLY PROFILE  //
    function adhdFriendlyProfile(CheckMark) {

        const enableAdhdFriendlyProfile = () => {
            readingMask(PARAMETER_EVENT.ONLOAD);
            body.classList.add("rcp-adhd-friendly-profile");
            localStorage.setItem("rcp-adhd-friendly-profile", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        }
        const disableAdhdFriendlyProfile = () => {
            body.classList.remove("rcp-adhd-friendly-profile");
            localStorage.removeItem("rcp-adhd-friendly-profile");
            activeIcon(PARAMETER_EVENT.NONE);
            readingMask(PARAMETER_EVENT.REMOVE);
        }

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (body.classList.contains("rcp-adhd-friendly-profile") && body.classList.contains("rcp-readingMask")) ? disableAdhdFriendlyProfile() : enableAdhdFriendlyProfile();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableAdhdFriendlyProfile();
        }
    }

    //  COGNITIVE DISABILITY PROFILE  //
    function cognitiveDisabilityProfile(CheckMark) {
        const enableCognitiveDisabilityProfile = () => {
            body.classList.add("rcp-cognitive-disability-profile");
            localStorage.setItem("rcp-cognitive-disability-profile", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        }
        const disableCognitiveDisabilityProfile = () => {
            body.classList.remove("rcp-cognitive-disability-profile");
            localStorage.removeItem("rcp-cognitive-disability-profile");
            activeIcon(PARAMETER_EVENT.NONE);
        }
        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            body.classList.contains("rcp-cognitive-disability-profile") ? disableCognitiveDisabilityProfile() : enableCognitiveDisabilityProfile();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableCognitiveDisabilityProfile();
        }
    }

    //  BLIND USERS SCREEN READER  //
    function blindUserScreenReader(CheckMark) {

        const enableBlindUserScreenReader = () => {
            body.classList.add("rcp-blind-user-screen-reader");
            localStorage.setItem("rcp-blind-user-screen-reader", PARAMETER_EVENT.OPEN);
            setScreenReaderToggle(true);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const disableBlindUserScreenReader = () => {
            body.classList.remove("rcp-blind-user-screen-reader");
            localStorage.removeItem("rcp-blind-user-screen-reader");
            setScreenReaderToggle(false);
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (body.classList.contains("rcp-blind-user-screen-reader")) ? disableBlindUserScreenReader() : enableBlindUserScreenReader();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableBlindUserScreenReader();
        }

        if (window.speechSynthesis) {
            const elements = document.querySelectorAll(ALL_ELEMENTS);
            const msg = new SpeechSynthesisUtterance();
            let voices = [];

            window.speechSynthesis.onvoiceschanged = function () {
                voices = window.speechSynthesis.getVoices();
                msg.voice = voices.length > 4 ? voices[4] : voices[0];
            };

            function speakText(value, element) {
                return new Promise((resolve, reject) => {
                    if (!value) return

                    const chunks = value?.split(". ");
                    let chunkIndex = 0;

                    function speakNextChunk() {
                        if (chunkIndex >= chunks.length) {
                            element.classList.remove("rcp-blind-user-screen-reader-highlight");
                            return resolve();
                        }
                        msg.text = chunks[chunkIndex];
                        window.speechSynthesis.speak(msg);
                        chunkIndex++;
                    }

                    msg.onend = () => {
                        if (chunkIndex < chunks.length) {
                            speakNextChunk();
                        } else {
                            element.classList.remove("rcp-blind-user-screen-reader-highlight");
                            resolve();
                        }
                    };

                    try {
                        window.speechSynthesis.cancel();
                        document.querySelectorAll(".rcp-blind-user-screen-reader-highlight").forEach((e) => e.classList.remove("rcp-blind-user-screen-reader-highlight"));
                        if (!element.getAttribute("aria-hidden")) {
                            element.classList.add("rcp-blind-user-screen-reader-highlight");
                        }
                        speakNextChunk();
                    } catch (e) {
                        reject(e);
                    }
                });
            }

            async function handleSpeech(event) {
                const element = event.target;

                if (body.classList.contains("rcp-blind-user-screen-reader")) {
                    function attribute(element, attri) {
                        return element.getAttribute(attri) && element.getAttribute(attri)
                    }
                    const value = attribute(element, "aria-label") || attribute(element, "title") || attribute(element, "placeholder") || attribute(element, "alt") || element.innerText;
                    // const value = element.getAttribute("aria-label") ? element.getAttribute("aria-label") : element.nodeName === ELEMENTS.IMG ? element.getAttribute("alt") : element.nodeName === ELEMENTS.INPUT || element.nodeName === ELEMENTS.TEXTAREA ? element.getAttribute("title") || element.getAttribute("placeholder") || element.getAttribute("aria-label") : element.innerText;
                    if (element.children.length > 0) {
                        const childElements = element.children;
                        for (let i = 0; i < childElements.length; i++) {
                            let updateValue = childElements[i].innerText ? childElements[i].innerText : value
                            await speakText(updateValue, childElements[i]);
                        }
                    } else {
                        await speakText(value, element);
                    }
                }
            }


            window.addEventListener("click", e => handleSpeech(e));

            elements.forEach(element => {
                element.addEventListener("focus", e => handleSpeech(e));
            });
        } else {
            console.error("Speech not supported by this browser");
        }
    }

    //  OVER SIZE WIDGET  //
    function overSizeWidget(CheckMark) {
        const enableOverSizeWidget = () => {
            body.classList.add("rcp-over-size-widget");
            localStorage.setItem("rcp-over-size-widget", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        }
        const disableOverSizeWidget = () => {
            body.classList.remove("rcp-over-size-widget");
            localStorage.removeItem("rcp-over-size-widget");
            activeIcon(PARAMETER_EVENT.NONE);
        }

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            body.classList.contains("rcp-over-size-widget") ? disableOverSizeWidget() : enableOverSizeWidget();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableOverSizeWidget();
        }
    }

    //  DYSLEXIC FONT  //
    function dyslexicFont(CheckMark) {
        const enableDyslexicFont = () => {
            body.classList.add("rcp-dylexic-font");
            localStorage.setItem("rcp-dylexic-font", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        }

        const disableDyslexicFont = () => {
            animationsStop(PARAMETER_EVENT.REMOVE);
            body.classList.remove("rcp-dylexic-font");
            localStorage.removeItem("rcp-dylexic-font");
            activeIcon(PARAMETER_EVENT.NONE);
        }

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            body.classList.contains("rcp-dylexic-font") ? disableDyslexicFont() : enableDyslexicFont();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableDyslexicFont();
        }
    }

    // KEYBOARD NAVIGATION //
    function keyboardNavigation(CheckMark) {
        let element = body.querySelectorAll(ACTIONS_ELEMENTS);

        const enableKeyNavigation = () => {
            html.classList.add("rcp-keyboard-navigation");
            for (let i = 0; i < element.length; i++) {
                let target = element[i].getAttribute('target');
                if (target && target === "_blank") {
                    //  ADD TOOLTIP CONTAINER  //
                    if (!element[i].querySelector('.rcp-key-navigation')) {
                        const newDiv = document.createElement("div");
                        newDiv.className = "rcp-key-navigation";
                        newDiv.innerHTML = "New Window"
                        element[i].appendChild(newDiv);
                        const position = window.getComputedStyle(element[i]).position;
                        if (position != "absolute" && position != "fixed" && position != "sticky" && position != "relative") {
                            element[i].style.position = 'relative'
                        }
                    }
                }
            }
            localStorage.setItem("rcp-keyboard-navigation", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        }
        const disableKeyNavigation = () => {
            html.classList.remove("rcp-keyboard-navigation");
            for (let i = 0; i < element.length; i++) {
                let target = element[i].getAttribute('target');
                if (target && target === "_blank") {
                    //  REMOVE TOOLTIP CONTAINER  //
                    let container = element[i].querySelector('.rcp-key-navigation')
                    if (container) {
                        element[i].removeChild(container);
                    }
                }
            }
            localStorage.removeItem("rcp-keyboard-navigation");
            activeIcon(PARAMETER_EVENT.NONE);
        }

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            html.classList.contains("rcp-keyboard-navigation") ? disableKeyNavigation() : enableKeyNavigation();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableKeyNavigation()
        }
    }

    return { SeizureSafeProfile, visionImpairedProfile, adhdFriendlyProfile, cognitiveDisabilityProfile, blindUserScreenReader, screenReaderToggle, overSizeWidget, dyslexicFont, keyboardNavigation }
}

export default useProfileAdjustment